import React, {useContext} from 'react';
import FormField, {Props} from '@src/components/Form/FormField';
import {IMaterialModel} from '@src/@interfaces/models/Material/IMaterialModel';
import {useFormContext} from 'react-hook-form';
import {FormFieldDesignContext} from '@src/contexts/FormFieldDesignContext';
import {InputGroup, InputGroupText} from 'reactstrap';
import Input from '@src/components/Form/fields/Input';
import {LocaleContext} from '@src/contexts/LocaleContext';
import trans from '@src/helpers/trans';
import RenderIf from '@src/components/RenderIf/RenderIf';

export default function MaterialVariableValueField<Model extends IMaterialModel = IMaterialModel>(props: Props<Model>) {
    const {locale} = useContext(LocaleContext);
    const {getFieldState, formState} = useFormContext<Model>();
    const [design] = useContext(FormFieldDesignContext);

    const isInvalid = (props as any).isInvalid ?? Boolean(getFieldState(props.fieldName as any, formState).error);

    const id = `${props.formName}@${props.fieldName}--${props.id}`;

    return <>
        <FormField
                type="number"
                id={id}
                label={trans(props.fieldLabel, locale)}
                fieldName={props.fieldName}
                fieldLabel={props.fieldLabel}
                config={props.config}
        >
            <InputGroup size={design?.size} className={isInvalid ? 'is-invalid' : undefined}>
                <RenderIf expression={props.model?.category?.unit}>
                    <InputGroupText>
                        {props.model?.category?.unit?.variable?.title}
                        <RenderIf expression={props.model?.category?.unit?.variable?.short_name}>
                            <span className="ms-1 text-muted">
                                [{props.model?.category?.unit?.variable?.short_name}]
                            </span>
                        </RenderIf>
                    </InputGroupText>
                </RenderIf>

                <Input
                        type="number"
                        step={0.01}
                        config={props.config}
                        fieldLabel={props.fieldLabel}
                        fieldName={props.fieldName}
                        id={id}
                        label={trans(props.fieldLabel, locale)}
                />

                <InputGroupText>
                    {props.model?.category?.unit?.title}
                </InputGroupText>
            </InputGroup>
        </FormField>
    </>;
}

MaterialVariableValueField.mutateValueBeforeDisplay = function (value: any): any {
    return value != null ? value / 100 : value;
};
